<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Imprimante B2546, B2650, M1246, MS521, MS621">
     Imprimante B2546, B2650, M1246, MS521, MS621
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ro" title="Informaţii de siguranţă">
     Informaţii de siguranţă
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Convenţii">
      Convenţii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Declaraţii produs">
      Declaraţii produs
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ro" title="Informaţii despre imprimantă">
     Informaţii despre imprimantă
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ro" title="Găsirea informaţiilor despre imprimantă">
      Găsirea informaţiilor despre imprimantă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_ro" title="Alegerea unui loc pentru imprimantă">
      Alegerea unui loc pentru imprimantă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_ro" title="Configurarea imprimantei">
      Configurarea imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_ro" title="Ataşarea cablurilor">
      Ataşarea cablurilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ro" title="Utilizare panou de comandă">
      Utilizare panou de comandă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ro" title="&Icirc;nţelegerea stării butonului de alimentare şi a indicatorului luminos">
      &Icirc;nţelegerea stării butonului de alimentare şi a indicatorului luminos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_ro" title="&Icirc;ncărcarea h&acirc;rtiei şi a suporturilor speciale">
     &Icirc;ncărcarea h&acirc;rtiei şi a suporturilor speciale
    </a>
   </p>
   <div id="divd0e735">
    <p class="toc-2-style">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media_ro" title="Setarea dimensiunii şi a tipului suporturilor speciale">
      Setarea dimensiunii şi a tipului suporturilor speciale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1_ro" title="Configurarea setărilor pentru formatul universal de h&acirc;rtie">
      Configurarea setărilor pentru formatul universal de h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_ro" title="&Icirc;ncărcarea tăvilor">
      &Icirc;ncărcarea tăvilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_ro" title="&Icirc;ncărcarea alimentatorului multifuncţional">
      &Icirc;ncărcarea alimentatorului multifuncţional
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_ro" title="Legarea tăvilor">
      Legarea tăvilor
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_ro" title="Suport pentru h&acirc;rtie">
     Suport pentru h&acirc;rtie
    </a>
   </p>
   <div id="divd0e933">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gsm-topic.html#supported-paper-sizes-gsm_ro" title="Dimensiuni acceptate pentru h&acirc;rtie">
      Dimensiuni acceptate pentru h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold_ro" title="Tipuri de h&acirc;rtie acceptate">
      Tipuri de h&acirc;rtie acceptate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm_ro" title="Greutăţi acceptate pentru h&acirc;rtie">
      Greutăţi acceptate pentru h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_ro" title="H&acirc;rtie neacceptată">
      H&acirc;rtie neacceptată
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_ro" title="Utilizarea h&acirc;rtiei reciclate">
      Utilizarea h&acirc;rtiei reciclate
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ro" title="Imprimare">
     Imprimare
    </a>
   </p>
   <div id="divd0e1540">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ro" title="Imprimarea de pe un computer">
      Imprimarea de pe un computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1566" title="Imprimarea de pe un dispozitiv mobil">
      Imprimarea de pe un dispozitiv mobil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ro" title="Imprimarea de pe o unitate flash">
      Imprimarea de pe o unitate flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_ro" title="Unităţi flash şi tipuri de fişiere acceptate">
      Unităţi flash şi tipuri de fişiere acceptate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_ro" title="Tipărirea unei liste de eşantioane de fonturi">
      Tipărirea unei liste de eşantioane de fonturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_ro" title="Tipărirea unei liste de directoare">
      Tipărirea unei liste de directoare
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ro" title="Despre meniurile imprimantei">
     Despre meniurile imprimantei
    </a>
   </p>
   <div id="divd0e1825">
    <p class="toc-2-style">
     <a href="menus-map-topic.html#menus-map_ro" title="Hartă meniuri">
      Hartă meniuri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e2054" title="Dispozitiv">
      Dispozitiv
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e3222" title="Imprimare">
      Imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e4184" title="H&acirc;rtie">
      H&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e4418" title="Reţea/Porturi">
      Reţea/Porturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e5977" title="Unitate USB">
      Unitate USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="security-audit-log-topic.html#d0e6140" title="Securitate">
      Securitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e6632" title="Rapoarte">
      Rapoarte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_ro" title="Asistenţă">
      Asistenţă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e6816" title="Rezolvarea problemelor">
      Rezolvarea problemelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_ro" title="Imprimarea paginii de setări meniuri">
      Imprimarea paginii de setări meniuri
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ro" title="Securizarea imprimantei">
     Securizarea imprimantei
    </a>
   </p>
   <div id="divd0e6874">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ro" title="Localizarea slotului de securitate">
      Localizarea slotului de securitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ro" title="Ştergerea memoriei imprimantei">
      Ştergerea memoriei imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ro" title="Revenirea la setările prestabilite din fabrică">
      Revenirea la setările prestabilite din fabrică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_ro" title="Declaraţie privind volatilitatea">
      Declaraţie privind volatilitatea
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ro" title="&Icirc;ntreţinerea imprimantei">
     &Icirc;ntreţinerea imprimantei
    </a>
   </p>
   <div id="divd0e7042">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e7047" title="Acces la reţea">
      Acces la reţea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_ro" title="Curăţarea imprimantei">
      Curăţarea imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_ro" title="Comandarea pieselor şi consumabilelor">
      Comandarea pieselor şi consumabilelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e7788" title="&Icirc;nlocuirea pieselor şi consumabilelor">
      &Icirc;nlocuirea pieselor şi consumabilelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e7932" title="Mutarea imprimantei">
      Mutarea imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e7987" title="Economisirea de energie şi h&acirc;rtie">
      Economisirea de energie şi h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e8113" title="Reciclare">
      Reciclare
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_ro" title="&Icirc;ndepărtarea blocajelor">
     &Icirc;ndepărtarea blocajelor
    </a>
   </p>
   <div id="divd0e8167">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_ro" title="Evitarea blocajelor">
      Evitarea blocajelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_ro" title="Identificarea locaţiilor blocajelor">
      Identificarea locaţiilor blocajelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_ro" title="Blocaj h&acirc;rtie &icirc;n uşa A">
      Blocaj h&acirc;rtie &icirc;n uşa A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_ro" title="Blocaj de h&acirc;rtie la uşa din spate">
      Blocaj de h&acirc;rtie la uşa din spate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_ro" title="Blocaj de h&acirc;rtie &icirc;n recipientul standard">
      Blocaj de h&acirc;rtie &icirc;n recipientul standard
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_ro" title="Blocaj de h&acirc;rtie &icirc;n unitatea duplex">
      Blocaj de h&acirc;rtie &icirc;n unitatea duplex
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_ro" title="Blocaj h&acirc;rtie &icirc;n tăvi">
      Blocaj h&acirc;rtie &icirc;n tăvi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_ro" title="Blocaj de h&acirc;rtie &icirc;n alimentatorul multifuncţional">
      Blocaj de h&acirc;rtie &icirc;n alimentatorul multifuncţional
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ro" title="Rezolvarea problemelor">
     Rezolvarea problemelor
    </a>
   </p>
   <div id="divd0e8443">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e8446" title="Probleme la conexiunea de reţea">
      Probleme la conexiunea de reţea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e8700" title="Probleme cu consumabilele">
      Probleme cu consumabilele
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_ro" title="Probleme cu alimentarea de h&acirc;rtie">
      Probleme cu alimentarea de h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_ro" title="Probleme de imprimare">
      Probleme de imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ro" title="Contactarea serviciului de asistenţă pentru clienţi">
      Contactarea serviciului de asistenţă pentru clienţi
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_ro" title="Actualizarea şi migrarea">
     Actualizarea şi migrarea
    </a>
   </p>
   <div id="divd0e11615">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e11618" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11807" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e11883" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ro" title="Note">
     Note
    </a>
   </p>
   <div id="divd0e11952">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e11955" title="Informaţii despre produs">
      Informaţii despre produs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e11972" title="Notă referitoare la ediţie">
      Notă referitoare la ediţie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ro" title="Mărci comerciale">
      Mărci comerciale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ro" title="Note de licenţă">
      Note de licenţă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ro" title="Niveluri de poluare fonică">
      Niveluri de poluare fonică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_ro" title="Directiva WEEE (Waste from Electrical and Electronic Equipment - Deşeuri din echipamente electrice şi electronice)">
      Directiva WEEE (Waste from Electrical and Electronic Equipment - Deşeuri din echipamente electrice şi electronice)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12074" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ro" title="Dezafectarea produsului">
      Dezafectarea produsului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12108" title="Baterie re&icirc;ncărcabilă litiu-ion">
      Baterie re&icirc;ncărcabilă litiu-ion
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_ro" title="Regulamentul (UE) 2023/1542">
      Regulamentul (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_ro" title="Returnarea cartuşelor Lexmark pentru reutilizare sau reciclare">
      Returnarea cartuşelor Lexmark pentru reutilizare sau reciclare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ro" title="Notificare de sensibilitate statică">
      Notificare de sensibilitate statică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ro" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ro" title="Informaţii cu privire la temperatură">
      Informaţii cu privire la temperatură
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ro" title="Notă cu privire la laser">
      Notă cu privire la laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ro" title="Consumul de energie">
      Consumul de energie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12348" title="Notificări &icirc;n legătură cu reglementările privind produsele care utilizează comunicaţiile fără fir">
      Notificări &icirc;n legătură cu reglementările privind produsele care utilizează comunicaţiile fără fir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ro" title="Notificare privind componentele modulare">
      Notificare privind componentele modulare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ro" title="Expunerea la radiaţii de radio-frecvenţă">
      Expunerea la radiaţii de radio-frecvenţă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_ro" title="Conformitate cu directivele Comisiei Europene (CE)">
      Conformitate cu directivele Comisiei Europene (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12382" title="Conformitate cu directivele Comisiei Europene (CE)">
      Conformitate cu directivele Comisiei Europene (CE)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue